var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-carousel",
        {
          staticClass: "w-100",
          attrs: {
            interval: 0,
            controls: _vm.sortedImageSrcList.length !== 1,
            indicators: _vm.sortedImageSrcList.length !== 1
          }
        },
        _vm._l(_vm.sortedImageSrcList, function(imageSrc, imageIndex) {
          return _c("b-carousel-slide", {
            key: imageSrc,
            scopedSlots: _vm._u(
              [
                {
                  key: "img",
                  fn: function() {
                    return [
                      imageIndex !== 0
                        ? _c("b-img-lazy", {
                            attrs: { src: imageSrc, alt: _vm.productName }
                          })
                        : _c("b-img", {
                            attrs: { src: imageSrc, alt: _vm.productName }
                          })
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              true
            )
          })
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }